<template>

  <div class="p-fluid report-field">
    <div class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
      <div class="p-col-fixed p-d-flex p-ai-center">
        <RadioButton v-model="checked" :inputId="guide.key+'_true'" :name="guide.key" :value="true" @change="dataChanged" :disabled="overview || guide.disabled" :class="{'p-invalid':guide.invalid}"/>
        <label :for="guide.key+'_true'" class="p-ml-1 p-mr-2">{{ $t('report.radio_yes') }}</label>
        <RadioButton v-model="checked" :inputId="guide.key+'_false'" :name="guide.key" :value="false" @change="dataChanged" :disabled="overview || guide.disabled" :class="{'p-invalid':guide.invalid}"/>
        <label :for="guide.key+'_false'" class="p-ml-1">{{ $t('report.radio_no') }}</label>
      </div>
    </div>
    <div>

      <Textarea v-if="!overview && guide.annotation" v-model="annotation" rows="2" cols="30" 
        :placeholder="$t('report.annotation_ph')"
        :disabled="guide.disabled"
        @input="annotationChanged($event.target.value)" :aria-label="$t('report.annotation_ph')"/>

      <span v-else-if="overview">{{ annotation ?? '-' }}</span>

    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      checked: null,
      annotation: null
    }
  },
  computed: {
  },
  created() {
    this.checked = this.data[this.guide.key];
    this.annotation = this.data[this.guide.annotation];
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged() {
      this.$emit("update:data", { key: this.guide.key, value: this.checked });
    },
    annotationChanged(newValue) {
      this.$emit("update:data", { key: this.guide.annotation, value: newValue });
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.checked = null;
        this.annotation = null;
      }
    }
  }
}
</script>

<style scoped>

</style>